/* autosize-on:
 *
 * Dynamically grow textareas.
 *
 * @dependencies: autosize
 *
 * Meant as more robust replacement of jquery.xarea.js / bb-xarea.js
 *
 * Copyright 2017 Berkeley Bridge
 *
 */

import { autosize } from "$autosize";
(function ($) {
  var first = false;

  function xarea(event, data) {
    if (
      typeof data != "undefined" &&
      data &&
      data.groups &&
      data.groups.length > 0
    )
      $(".group textarea")
        .filter(function () {
          return !this.getAttribute("data-p-autosize-on");
        })
        .each(function (_, area) {
          autosize(area);
          return area;
        })
        .attr("data-p-autosize-on", true);
  }

  $(document).on("bb:postHandleData", function (event, data) {
    if (first) {
      window.setTimeout(function () {
        xarea(event, data);
      }, 150);
      first = false;
    } else {
      xarea(event, data);
    }
  });
})(jQuery);
